import { Injectable,inject } from '@angular/core';
import { HttpService } from './http.service';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginResponse } from '../models/user.model';
import { Router } from '@angular/router';
import { Auth, EruAuthConfig } from '../models/eruauth.model';
import { projectStore } from '../stores/project.store';

@Injectable({
  providedIn: 'root'
})
export class EruAuthService {
  private router = inject(Router);

  constructor(private httpService: HttpService) { }

  fetchConfig(url:string,project_name: string): Observable<{ project: EruAuthConfig }> {
    return this.httpService.get<any>(
      `${url}/store/${project_name}/config`      
    ).pipe(
      map(response => {
        if (response && response.project) {
          return { project: response.project };
        } else {
          return { project: {} };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('API Error:', error);
        return throwError(() => new Error(error.error?.error || 'Projects not found'));
      })
    );
  }

  

  saveAuth(url:string,project_name:string,authData:Auth):Observable<any>{
    return this.httpService.post<any>(
      `${url}/store/${project_name}/save/auth`,
      authData
    ).pipe(
      tap(response=>console.log('Auth saved successfully: ',response)),
      catchError((error:HttpErrorResponse)=>{
        console.error('API Error');
        return throwError(()=> new Error(error.error?.error||'Failed to save Auth'));
      })
    );
  }

  // eru-auth has no separate update route; save/auth is an upsert keyed by auth_name.
  updateAuth(url: string, project_name: string, authData: Auth): Observable<any> {
    return this.saveAuth(url, project_name, authData);
  }

  fetchFuncList(url: string, project_name: string): Observable<string[]> {
    return this.httpService.get<any>(`${url}/store/${project_name}/func/list`).pipe(
      map((response) => {
        const functions: any[] = Array.isArray(response?.functions) ? response.functions : [];
        return functions
          .map((f) => (typeof f === 'string' ? f : f?.func_name))
          .filter((name): name is string => !!name);
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('API Error:', error);
        return throwError(() => new Error(error.error?.error || 'Failed to load functions'));
      })
    );
  }

  deleteAuth(url:string,project_name:string,authData:Auth):Observable<any>{
    return this.httpService.delete<any>(
      `${url}/store/${project_name}/remove/auth/${authData.auth_name}`,
    ).pipe(
      catchError((error:HttpErrorResponse)=>{
        console.log('API Error:',error);
        return throwError(()=>new Error(error.error?.error||'Failed to delete Auth'))
      })
    )
  }

  loginWithUserPassword(url: string, username: string, password: string): Observable<LoginResponse> {
    return this.httpService.post<LoginResponse>(
      url,
      { username, password }
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('API Error:', error);
        return throwError(() => new Error(error.error?.error || 'Login failed'));
      })
    );
  }
}